module.exports = __webpack_public_path__ + "static/media/Right_Arrow@3x.6d7443a0.png";